import { render } from "./Designer.vue?vue&type=template&id=4ffde8cf&scoped=true&ts=true"
import script from "./Designer.vue?vue&type=script&lang=ts"
export * from "./Designer.vue?vue&type=script&lang=ts"

import "./Designer.vue?vue&type=style&index=0&id=4ffde8cf&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffde8cf"]])

export default __exports__